<template>
  <div class="home1">
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <Other-Website :domain="webUrl" />
    <!-- <Help-section></Help-section> -->
  </div>
</template>

<script>
// @ is an alias to /src
import OtherWebsite from '@/components/otherWebsite/OtherWebsite.vue'
import { getDomainFromWebsite } from './../assets/util/uriUtil.js'
// import helpSection from '@/components/help/Helpmenu.vue'

export default {
  name: 'OtherWebsiteView',
  components: {
    'Other-Website': OtherWebsite
    // 'Help-section': helpSection
  },
  data: function() {
    return {
      webUrl: null
    }
  },
  methods: {
    addListenerForMsgFromPlugin() {
      const that = this
      window.addEventListener(
        'message',
        function(ev) {
          if (ev && ev.data && ev.data.type == 'other-website-mode') {
            that.webUrl = getDomainFromWebsite(ev.data.data)
          }
        },
        true
      )
    }
  },
  beforeMount: function() {
    this.addListenerForMsgFromPlugin()
  }
}
</script>
